import { fr } from 'date-fns/locale';

export const useDefaultLocale = ():Locale => {
    return fr;
}